import { useIntl } from "react-intl";
import { ClearableInput, Dialog, Spinner } from "@rio-cloud/rio-uikit";
import { IAssetManuals } from "../../../../hooks/useAssetManuals";
import { useChassisCopy } from "../../../../hooks/useChassisCopy";

interface IManualDialogProps {
    show: boolean;
    close: () => void;
    manuals: IAssetManuals | null;
    loading: boolean;
    chassis: string;
}

export const ManualDialog = (props: IManualDialogProps) => {
  const intl = useIntl();
  const { copyChassis } = useChassisCopy();

  const handleCopyChassis = async () => {
    const success = await copyChassis(props.chassis);
    if (success) {
      // Mostra notificação simples
      const notification = document.createElement('div');
      notification.textContent = 'Item Copiado';
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #10b981;
        color: white;
        padding: 12px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 9999;
        font-size: 14px;
        font-weight: 500;
        animation: slideIn 0.3s ease-out;
      `;
      
      // Adiciona animação CSS
      const style = document.createElement('style');
      style.textContent = `
        @keyframes slideIn {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
      `;
      document.head.appendChild(style);
      
      document.body.appendChild(notification);
      
      // Remove após 3 segundos
      setTimeout(() => {
        notification.style.animation = 'slideIn 0.3s ease-out reverse';
        setTimeout(() => {
          document.body.removeChild(notification);
          document.head.removeChild(style);
        }, 300);
      }, 3000);
    }
  };

    return <Dialog
    show={props.show}
    title={intl.formatMessage({ id: "intl-msg:monitoring.manual.title" })}
    onCloseValidation={() => {
        props.close();
        return true;
    }}
    showCloseButton
    bsSize="md"
    body={
      <div className="w-full mx-auto bg-white rounded-lg manuals-content">
        <div className="flex items-end gap-6 border-b pb-5">
          <div className="form-group w-4/6">
            <label htmlFor="chassi-search">{intl.formatMessage({ id: "intl-msg:monitoring.manual.chassisLabel" })}</label>
            <div className="input-group relative" onClick={handleCopyChassis} title={intl.formatMessage({ id: "intl-msg:monitoring.manual.copyTooltip" })}>
              <input
                id="chassi-search"
                type="text"
                className="form-control cursor-pointer"
                value={props.chassis}
                readOnly
                style={{ pointerEvents: 'none' }}
              />
            </div>
          </div>
          <div className="form-group w-2/6">
            <label htmlFor="ano">{intl.formatMessage({ id: "intl-msg:monitoring.manual.year" })}</label>
            <div className="input-group">
              <input
                id="ano"
                type="number"
                value={props.manuals?.year || ""}
                className="form-control no-controls"
                disabled
              />
            </div>
          </div>
        </div>

        {!props.loading && props.manuals?.manuals && props.manuals.manuals.length > 0 && (
          <table className="table table-bordered mt-4">
            <thead>
              <tr>
                <th>{intl.formatMessage({ id: "intl-msg:monitoring.manual.manualName" })}</th>
                <th className="text-center">{intl.formatMessage({ id: "intl-msg:monitoring.manual.download" })}</th>
              </tr>
            </thead>
            <tbody>
              {props.manuals.manuals.map((manual, index) => (
                <tr key={index}>
                  <td>{manual.name}</td>
                  <td className="text-center">
                    <a
                      href={manual.downloadLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-color-darker"
                    >
                      <span className="rioglyph rioglyph-cloud-download text-size-20 text-color-darker" />
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {!props.loading && !props.manuals?.manuals?.length && (
          <div className="flex justify-center items-center h-full m-4">
            <p className="text-center">{intl.formatMessage({ id: "intl-msg:monitoring.manual.noManualsFound" })}</p>
          </div>
        )}

        {props.loading && (
          <div className="flex justify-center items-center h-full m-4">
            <Spinner /> <div className="ml-4">{intl.formatMessage({ id: "intl-msg:monitoring.manual.loading" })}</div>
          </div>
        )}
      </div>
    }
  />
}